import { Injectable } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';

@Injectable({
  providedIn: 'root'
})
export class UtilsService {

  isFormEmpty(formGroup: FormGroup): boolean {
    const formValues = formGroup.value;

    return !Object.values(formValues).some(value => {

      if (Array.isArray(value)) {
        return value.length !== 0;
      }

      if (typeof value === 'string') {
        return value.trim() !== '';
      }

      if (value instanceof Date) {
        return value !== null;
      }

      return value !== null && value !== undefined;
    });
  }

  /**
   * Compares two objects to determine if they are equal in terms of structure and values.
   *
   * @param object_1 - First object to compare.
   * @param object_2 - Second object to compare.
   * @returns boolean - Returns `true` if both objects are equal, otherwise `false`.
  */
  isObjectsEquals(object_1: any, object_2: any): boolean {

    const keys1 = Object.keys(object_1);
    const keys2 = Object.keys(object_2);
    if (keys1.length !== keys2.length) {
      return false;
    }

    for (const key of keys1) {
      if (!object_2.hasOwnProperty(key)) {
        return false;
      }

      if (Array.isArray(object_1[key]) && Array.isArray(object_2[key])) {
        if (object_1[key].length !== object_2[key].length) {
          return false;
        }
        for (let i = 0; i < object_1[key].length; i++) {
          if (!this.isObjectsEquals(object_1[key][i], object_2[key][i])) {
            return false;
          }
        }
      } else if (typeof object_1[key] === 'object' && typeof object_2[key] === 'object') {
        if (!this.isObjectsEquals(object_1[key], object_2[key])) {
          return false;
        }
      } else {
        if (object_1[key] !== object_2[key]) {
          return false;
        }
      }
    }

    return true;
  }

  isArraysEquals(array_1: any[], array_2: any[]): boolean {
    if (array_1.length !== array_2.length) {
      return false;
    }

    for (let i = 0; i < array_1.length; i++) {
      const value_1 = array_1[i];
      const value_2 = array_2[i];

      if (typeof value_1 === 'object' && typeof value_1 !== null &&
        typeof value_2 === 'object' && typeof value_2 !== null) {
        if (!this.isObjectsEquals(value_1, value_2)) {
          return false;
        }
      } else if (Array.isArray(value_1) && Array.isArray(value_2)) {
        if (!this.isArraysEquals(value_1, value_2)) {
          return false;
        }
      } else if (value_1 !== value_2) {
        return false;
      }
    }

    return true;
  }

/** https://dev.to/fpaghar/remove-duplicates-ways-from-an-array-in-javascript-3k1d
 * 
 * @param array Array with duplicate objects
 * @param key Key for which we want to make the comparison
 * @returns An array without duplicate objects
 * 
 */
  removeObjectsDuplicated(array: any[], key: string) {
    return array.filter(
      (obj, index, self) => index === self.findIndex((t) => t[key] === obj[key])
    )
  }
}
